<template>
    <el-dialog title="Сброс двухфакторной аутентификации" :visible.sync="visibleModalModel" width="350px" :append-to-body="true">
        <div v-loading="loading">
            <template v-if="state === 'question'">
                <div style="word-break: normal" class="text-lg mb-3">Сбросить двухфакторную аутентификацию для пользователя <span class="font-weight-bold">{{user.name}} <span>{{user.login}}</span></span>?</div>
                <button class="btn btn-primary btn-block" @click="reset2FA">Да</button>
            </template>
            <template v-else>
                <div style="word-break: normal" class="text-lg text-success mb-3">При следующей авторизации, пользователю необходимо отсканировать QR код в приложении Google Authenticator</div>
            </template>
        </div>
    </el-dialog>
</template>

<script>
export default {
    name: "ModalReset2FA",
    props: ['visibleModal', 'user'],
    data: () => ({
        state: "question",

        loading: false,
    }),
    computed: {
        visibleModalModel: {
            get () { return this.visibleModal },
            set (value) { this.$emit('update:visibleModal', value) },
        },
    },
    methods: {
        reset2FA() {
            let self = this;
            this.loading = true;

            axios.post('/api/users/' + this.user.id + '/reset2fa')
                .then(() => {
                    self.loading = false;
                    self.state = 'finish';
                })
        }
    }
}
</script>

<style scoped>

</style>
